var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 27,
    viewBox: "0 0 48 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1402_6314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3033 15.7312C30.0121 14.7129 27.1921 13.9687 24 13.9687C20.8079 13.9687 17.9879 14.7325 15.6967 15.7312C13.5817 16.6712 12.25 18.7862 12.25 21.0971V24.25H35.75V21.0971C35.75 18.7862 34.4183 16.6712 32.3033 15.7312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88917 17.5525C1.44 18.1792 0.5 19.5892 0.5 21.1754V24.25H9.3125V21.0971C9.3125 19.4717 9.76292 17.9442 10.5462 16.6125C9.82167 16.495 9.09708 16.4167 8.33333 16.4167C6.39458 16.4167 4.55375 16.8279 2.88917 17.5525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1108 17.5525C43.4462 16.8279 41.6054 16.4167 39.6667 16.4167C38.9029 16.4167 38.1783 16.495 37.4538 16.6125C38.2371 17.9442 38.6875 19.4717 38.6875 21.0971V24.25H47.5V21.1754C47.5 19.5892 46.56 18.1792 45.1108 17.5525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.5C27.2508 12.5 29.875 9.87583 29.875 6.625C29.875 3.37417 27.2508 0.75 24 0.75C20.7492 0.75 18.125 3.37417 18.125 6.625C18.125 9.87583 20.7492 12.5 24 12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33314 5.6397L3.43117 10.5417L8.33314 15.4436L13.2351 10.5417L8.33314 5.6397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 6.625L34.7708 14.4583H44.5625L39.6667 6.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1402_6314",
    x: 0.5,
    y: 0.75,
    width: 47,
    height: 25.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1402_6314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1402_6314",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.79e86c21a8c5d13e4169981c161c1301.svg";
export { ForwardRef as ReactComponent };